import { css, useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import { useState } from "react";

import Details from "./Details.jsx";
import handleComponentsProp from "./handleComponentsProp.js";
import parseStyle from "./parseStyle.js";
import Stack from "./Stack.jsx";
import useThemeProps from "./useThemeProps.jsx";

const AccordionList = styled(Stack)``;
const AccordionItem = styled(Details)``;

export default function Accordion(props) {
  const theme = useTheme();
  props = useThemeProps({
    props,
    name: "Accordion",
  });

  let {
    items,
    // iconColor,
    // showExpandAll,
    spacing,
    marginBefore,
    marginAfter,
    divider,
    components,
    itemProps = {},
    style = {},
    ...restProps
  } = props;

  let { List, Item } = handleComponentsProp(components, {
    List: AccordionList,
    Item: AccordionItem,
  });

  const [expandedRowIndexes, setExpandedRowIndexes] = useState([]);

  const rowIsExpanded = (index) => {
    return expandedRowIndexes.indexOf(index) !== -1;
  };

  // const onToggleAll = () => {
  //   if (expandedRowIndexes.length) {
  //     setExpandedRowIndexes([]);
  //   } else {
  //     const allRowIndexes = Array.from(Array(items.length).keys());
  //     setExpandedRowIndexes(allRowIndexes);
  //   }
  // };

  return (
    <div
      css={css`
        ${parseStyle(style, theme)}
      `}
      {...restProps}
    >
      {/* {showExpandAll && (
        <button onClick={onToggleAll}>
          {expandedRowIndexes.length ? <>CLOSE</> : <>OPEN</>}
        </button>
      )} */}
      <List
        direction="column"
        spacing={spacing}
        divider={divider}
        marginBefore={marginBefore}
        marginAfter={marginAfter}
      >
        {items.map((item, index) => {
          return (
            <Item
              key={index}
              summary={item.title}
              isExpanded={rowIsExpanded(index)}
              onToggle={(isExpanded) => {
                setExpandedRowIndexes((prev) => {
                  if (isExpanded) {
                    return prev.filter((i) => i !== index);
                  } else {
                    return [...prev, index];
                  }
                });
              }}
              {...itemProps}
            >
              {item.content}
            </Item>
          );
        })}
      </List>
    </div>
  );
}
